import { normalizeSlotLabel } from "./slotLabel";
import type { VariantConfig } from "./variantConfig";

/** Slot labels referenced by a named-variant default config (transform and/or delta). */
export function slotsFromVariantConfig(config: VariantConfig): string[] {
  const fromRules =
    config.mode === "transform" || config.mode === "hybrid"
      ? config.rules.flatMap((r) => r.slots.map((s) => normalizeSlotLabel(s)).filter(Boolean))
      : [];
  const fromLines =
    config.mode === "delta" || config.mode === "hybrid"
      ? (config.delta_lines ?? [])
          .map((ln) => normalizeSlotLabel(ln.slot_label))
          .filter(Boolean)
      : [];
  const fromScale =
    config.mode === "delta" || config.mode === "hybrid"
      ? (config.slot_scale_rules ?? [])
          .map((r) => normalizeSlotLabel(r.slot_label))
          .filter(Boolean)
      : [];
  const fromProportional =
    config.mode === "delta" || config.mode === "hybrid"
      ? (config.proportional_add_rules ?? []).flatMap((r) => {
          const source = normalizeSlotLabel(r.source_slot_label);
          const target =
            typeof r.slot_label === "string" && r.slot_label.trim()
              ? normalizeSlotLabel(r.slot_label)
              : "";
          return [source, target].filter(Boolean);
        })
      : [];
  return [...new Set([...fromRules, ...fromLines, ...fromScale, ...fromProportional])];
}
